import { Button, Typography, useTheme } from "@mui/material";
import React, { useMemo } from "react";
import LinkIcon from "@mui/icons-material/Link";
import CheckIcon from "@mui/icons-material/Check";
import { ShareConfigCodeRoot } from "./ShareConfigCode.styles";
import ShareIcon from "@mui/icons-material/Share";
import { useClipboard } from "../../hooks/useClipboard";

export const ShareConfigCode = () => {
  const theme = useTheme();
  const { handleCopy, copyStatus } = useClipboard();
  // 1. Get the current URL from the browser's window object.
  const urlToCopy = useMemo(() => {
    // Check if running in a browser environment
    if (typeof window !== "undefined") {
      return window.location.href;
    }
    return ""; // Return empty string on server side
  }, []);

  const handleClick = () => {
    handleCopy(urlToCopy);
  };

  /**
   * Tries to use the Web Share API to open the native sharing dialog.
   */
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "My WYDST R8S Configuration",
          text: "Check out my WYDST R8S own configuration!",
          url: urlToCopy,
        });
        // console.log("Content shared successfully");
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      // Fallback if Web Share API is not supported (e.g., desktop browser)
      console.warn("Web Share API not supported on this device/browser.");
      // For desktop, usually clicking "Copy configuration link" is the expectation,
      // or you would implement a custom modal with social links here.
    }
  };

  const buttonText =
    copyStatus === "success" ? "Link Copied!" : "Copy configuration link";
  const buttonIcon = copyStatus === "success" ? <CheckIcon /> : <LinkIcon />;

  return (
    <ShareConfigCodeRoot>
      <Button
        startIcon={buttonIcon}
        onClick={handleClick}
        sx={{
          flex: 1,
          color:
            copyStatus === "success"
              ? theme?.palette?.companyColors?.secondary
              : theme?.palette?.companyColors?.neutral,
          background:
            copyStatus === "success"
              ? theme?.palette?.companyColors?.greyLight1
              : theme?.palette?.companyColors?.primary,
          borderRadius: theme?.borderRadius?.small,
          padding: { xs: "0.75rem 5rem", xl: "1rem 2rem" },
        }}
        disabled={copyStatus === "success"} // Optional: Disable button when success message is shown
      >
        <Typography
          variant="button"
          sx={{
            textTransform: "initial",
            fontSize: { xs: "1.85rem", lg: "1.75rem" },
            fontWeight: 400,
          }}
        >
          {buttonText}
        </Typography>
      </Button>
      <Button
        startIcon={<ShareIcon />}
        sx={{
          flex: 1,
          color: theme?.palette?.companyColors?.neutral,
          background: theme?.palette?.companyColors?.primary,
          borderRadius: theme?.borderRadius?.small,
          padding: { xs: "0.75rem 5rem", xl: "1rem 2rem" },
          width: "100%",
        }}
        onClick={handleShare}
      >
        <Typography
          variant="button"
          sx={{
            textTransform: "initial",
            fontSize: { xs: "1.85rem", lg: "1.75rem" },
            fontWeight: 400,
          }}
        >
          Share
        </Typography>
      </Button>
    </ShareConfigCodeRoot>
  );
};
